import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	TPayloadDeleteUnitSettingRequest,
	TPayloadGetUnitSettingListRequest,
	TPayloadGetUnitSettingSuccess,
	TPayloadUpdateUnitSettingRequest,
	TUnitSettingStore,
} from './us1-01-unit-setting.type';

const initialState = {
	fetching: false,
	unitSettingMasterInfo: {
		districtList: [],
		issuanceStatusList: [],
		optionalFieldApplicantList: [],
		optionalFieldFranchiseList: [],
		statusList: [],
		districtListOption: [],
		issuanceStatusListOption: [],
		statusListOption: [],
	} as TUnitSettingStore,
};

const unitSettingSlice = createSlice({
	initialState,
	name: 'us1_01UnitSetting',
	reducers: {
		/**---- GET US1_01_UNIT_SETTING START ---- */
		getUnitSettingRequest: (
			state,
			action: PayloadAction<TPayloadGetUnitSettingListRequest>
		) => {
			state.fetching = true;
		},
		getUnitSettingSuccess: (
			state,
			action: PayloadAction<TPayloadGetUnitSettingSuccess>
		) => {
			const { unitSettingList } = action.payload;
			state.fetching = false;
			state.unitSettingMasterInfo = unitSettingList;
		},
		getUnitSettingFailure: (state) => {
			state.fetching = false;
		},

		updateUnitSettingRequest: (
			state,
			action: PayloadAction<TPayloadUpdateUnitSettingRequest>
		) => {
			state.fetching = true;
		},

		updateUnitSettingSuccess: (state) => {
			state.fetching = false;
		},

		updateUnitSettingFailure: (state) => {
			state.fetching = false;
		},

		deleteUnitSettingRequest: (
			state,
			action: PayloadAction<TPayloadDeleteUnitSettingRequest>
		) => {
			state.fetching = true;
		},

		deleteUnitSettingSuccess: (state) => {
			state.fetching = false;
		},

		deleteUnitSettingFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET US1_01_UNIT_SETTING END ---- */
	},
});

export const Us1_01UnitSettingSelectors = {
	selectFetching: (state: RootState) => state.us1_01UnitSetting.fetching,
	selectUnitSettingMasterInfo: (state: RootState) =>
		state.us1_01UnitSetting.unitSettingMasterInfo,
};

export const UnitSettingActions = unitSettingSlice.actions;
export const UnitSettingReducer = unitSettingSlice.reducer;
